import React, { Component } from 'react';
import { FaStar } from "react-icons/fa";

class CabIcon extends Component {
  
  constructor(props) {
    super(props);
  }
  render() {
    const {items} = this.props;

    return (
      <>
      { items.original.isPremium == true ?
        <FaStar title="Premium bil" style={{color:"#d4af37", marginLeft: '0.25em'}} />
      :
      
      <></>
      }
      </>
    )
  }
}

export default CabIcon;